import React from "react";
import "./SiteLoader.scss";

const SiteLoader = () => {
  return (
    <>
      <div id="overlay">
        <div className="spinner"></div>
      </div>
    </>
  );
};

export default SiteLoader;
